// extracted by mini-css-extract-plugin
export default {"popover":"DeleteDraftPopover_popover__rcJkx","panel":"DeleteDraftPopover_panel__1hgcd"};